import React, {useMemo, useState} from 'react';
import styled, {useTheme} from "styled-components";
import TierTag from "../../common/TierTag";
import {ImageLane} from "../../common";
import {getRegionServer, romanNumberConverter, threedigits} from "../../../function";
import RankingWinRate from "../../Ranking/RankingContent/RankingTable/RankingTableContent/RankingWinRate";
import ChampionImageWithLane from "../../common/ChampionImageWithLane";
import InfluInfo from "../../summoner/Profile/InfluInfo";
import useTimeHook from "../../../common/hooks/useTimeHook";
import ToSummonerLink from "../../Link/ToSummonerLink";
import {serverTypeToString} from "../function/customClanFunction";
import {MarginBox} from "../../ui/styled";
import useHover from "../../../common/hooks/useHover";
import {CopyToClipboard} from "react-copy-to-clipboard";

const Wrapper = styled.div`
  border-radius: 8px;
  width: 100%;
  overflow: hidden;

  table {
    width: 100%;
  }
`;
const Thead = styled.thead`
  background-color: ${props => props.theme.color.white_100};
`;
const HeadTr = styled.tr`
  height: 40px;
`;
const HeadTh = styled.th`
  color: ${props => props.theme.color.dark_200};
  font-weight: 500;
  font-size: 12px;
  vertical-align: middle;
`;
const BodyTd = styled.td`
  width: ${props => props.width};
  vertical-align: middle;
`;
const RankingText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;

const BodyTr = styled.tr`
  height: 40px;

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }

  &.light + &.light {
    border-top: 1px solid ${props => props.theme.color.gray_200};
  }

  &.dark + &.dark {
    border-top: 1px solid ${props => props.theme.color.gray_200};
  }
`;

const SummonerText = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: ${props => props.theme.color.dark_100};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
const CenterBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .percent {
    color: ${props => props.theme.color.dark_200};
  }

  .win-rate-bar {
    width: 120px;
  }
`;
const NameCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  a {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 208px;
  }
`;
const RatioText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${props => {
    let color = props.theme.color.gray_400;
    if (props.score === 'Perfect') {
      color = props.theme.color.yellow_100;
    } else if (props.score >= 4.0) {
      color = props.theme.color.yellow_100;
    } else if (props.score >= 3.0) {
      color = props.theme.color.blue_400;
    } else if (props.score >= 2.0) {
      color = props.theme.color.green_300;
    }
    return color;
  }
  };
`;
const InflueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: 100%;
  overflow: hidden;
`;
const CustomClanDetailTable = ({list,  serverType}) => {
    const theme = useTheme();
    const twentyPercent = useMemo(() => {
        try {
            return Math.ceil(list.length * 0.2)
        } catch (e) {
            return 1;
        }
    }, [list]);
    return (
        <Wrapper>
            <table>
                <Thead>
                    <HeadTr>
                        <HeadTh>
                            #
                        </HeadTh>

                        <HeadTh>
                            소환사명
                        </HeadTh>
                        <HeadTh>
                            포지션
                        </HeadTh>
                        <HeadTh>
                            티어
                        </HeadTh>
                        <HeadTh>
                            모스트 챔피언
                        </HeadTh>
                        <HeadTh>
                            KDA
                        </HeadTh>
                        <HeadTh>
                            승률
                        </HeadTh>
                        <HeadTh>
                            게임 수
                        </HeadTh>
                        <HeadTh>
                            최근 게임
                        </HeadTh>


                    </HeadTr>
                </Thead>
                <tbody>
                {list.map((data, index) => {
                    const splitTier = data?.tier?.split(" ");
                    if (twentyPercent === index + 1) {
                        return (
                            <React.Fragment key={index}>
                                <CustomClanDetailTableContent data={data} splitTier={splitTier} />
                                <AdvertiseContent serverType={serverType}/>
                            </React.Fragment>
                        )
                    }
                    return (
                        <CustomClanDetailTableContent data={data} splitTier={splitTier} key={index} rank={index + 1}/>
                    )
                })}
                </tbody>
            </table>
        </Wrapper>
    );
};

const AdvertiseRedText = styled.span`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  color: ${props => props.theme.color.red_100};
`;

const EmojiBox = styled.div`
  background-color: ${props => props.theme.color.default_border_color};
  width: 28px;
  height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  text-align: center;
`;


const YellowText = styled.div`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  text-align: center;

  color: #FFA31A;
`;

const AdvertiseGreenButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 120px;
  height: 24px;
  background-color: ${props => props.theme.color.green_100};
  color: #fff;
  font-weight: 800;
  font-size: 12px;
  line-height: 100%;
`;

const AdvertiseGreenButtonText = styled.div`
  width: 40px;
  margin-left: 8px;
  color: #DE5353;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
`;
const Percent = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
  margin-left: 3px;
`;


const CursorBody = styled(BodyTr)`
    cursor: pointer;
`;
const AdvertiseContent = ({serverType}) => {
    const theme = useTheme();
    const serverTypeString = serverTypeToString(serverType);
    const onClickTr = () => {
        window.open(`https://discord.gg/3pQGtfQMe9`, '_blank');
    }
    return (
        <CursorBody className={theme.color.theme} onClick={onClickTr}>
            <BodyTd width={'74.5px'}>
                <RankingText>-</RankingText>
            </BodyTd>
            <BodyTd width={'227.5px'}>
                <NameCenter>
                    <AdvertiseRedText>나도 이런 클랜 만들러 가보기</AdvertiseRedText>
                </NameCenter>
            </BodyTd>
            <BodyTd width={'83.5px'}>
                <CenterBox>
                    {serverType > 0 &&
                        <img src={`${theme.icon.path}/connect/${serverTypeString.img}`} width={20} height={20} alt={''}/>}
                </CenterBox>
            </BodyTd>
            <BodyTd width={'115.5px'}>
                <CenterBox>
                    <img src={`${theme.icon.path}/connect/img_connect_infinite.svg`} width={27} alt={''}/>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'139.5px'}>
                <CenterBox>
                    <MostChampsWrapper>
                        <EmojiBox>
                            🤝
                        </EmojiBox>
                        <EmojiBox>
                            🎯
                        </EmojiBox>
                        <EmojiBox>
                            📈
                        </EmojiBox>
                    </MostChampsWrapper>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'67.5px'}>
                <CenterBox>
                    <YellowText>NEW</YellowText>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'199.5px'}>
                <CenterBox>
                        <AdvertiseGreenButton>
                            <MarginBox margin={'0 8px 0 0'}>
                                <div>
                                    <span>커넥트 서버 만들기</span>
                                </div>
                            </MarginBox>
                            <img src={'/images/connect/icon_arrow_right.svg'} width={5} height={10} alt={''}/>
                        </AdvertiseGreenButton>
                    <AdvertiseGreenButtonText>
                        <span>100<Percent>%</Percent></span>
                    </AdvertiseGreenButtonText>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'83.5px'}>
                <CenterBox>
                    <RankingText>파티원 999</RankingText>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'87px'}>
                <CenterBox>
                    <RankingText>지금 바로</RankingText>
                </CenterBox>
            </BodyTd>
        </CursorBody>
    )
}

const CustomClanDetailTableContent = ({data, splitTier, }) => {
    const {lessMinWithIntl} = useTimeHook();
    const theme = useTheme()
    return (
        <BodyTr className={theme.color.theme}>
            <BodyTd width={'74.5px'}>
                <RankingText>{data.rank}</RankingText>
            </BodyTd>
            <BodyTd width={'227.5px'}>
                <SummonerHover data={data}/>
            </BodyTd>
            <BodyTd width={'83.5px'}>
                <CenterBox>
                    <ImageLane lane={data.most_position} color={'dark'}/>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'115.5px'}>
                <CenterBox>
                    <TierTag
                        tier={splitTier[0]}
                        division={romanNumberConverter(splitTier[1])}
                    />
                </CenterBox>
            </BodyTd>
            <BodyTd width={'139.5px'}>
                <CenterBox>
                    <MostChamps list={data.most_three_champ}/>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'67.5px'}>
                <CenterBox>
                    <RatioText score={data.kda.toFixed(2)}>{data.kda.toFixed(2)}</RatioText>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'199.5px'}>
                <CenterBox>
                    <RankingWinRate
                        lose={data.cnt - data.win}
                        win={data.win}
                    />
                </CenterBox>
            </BodyTd>
            <BodyTd width={'83.5px'}>

                <CenterBox>
                    <RankingText>{threedigits(data.cnt)}</RankingText>
                </CenterBox>
            </BodyTd>
            <BodyTd width={'87px'}>
                <CenterBox>
                    <RankingText>{lessMinWithIntl(data.creation_timestamp * 1000)}</RankingText>
                </CenterBox>
            </BodyTd>
        </BodyTr>
    )
}


const SummonerHoverBox = styled.div`
  position: relative;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const SummonerHoverButton = styled.button`
  width: 40px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  border-radius: 4px;
  background-color: ${props => props.theme.color.white_201};
  border: 1px solid ${props => props.theme.color.black_border_color};
  color: ${props => props.theme.color.green_100};
`;
const CopyAbsolute = styled.div`
  border-radius: 8px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -40px;
  left: -20px;
  background-color: rgba(0, 0, 0, 0.85);
  color: #fff;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
  width: 260px;
`;
const SummonerHover = ({data}) => {
    const [onHover, handleMouseOver, handleMouseOut] = useHover()
    const [copy, setCopy] = useState(false);

    const handleCopy = () => {
        setCopy(true);
        closeCopied();
    };

    // 공유하기 툴팁
    const closeCopied = () => {
        setTimeout(() => {
            setCopy(false);
        }, 2000);
    };
    return (
        <SummonerHoverBox onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <NameCenter>
                <TextWrapper>
                    <ToSummonerLink puu_id={data?.puu_id}
                                    name={`${data?.riot_name}-${data?.riot_tag}`}
                                    region={getRegionServer(data.platform_id)}>
                        <SummonerText>{data.riot_name} #{data.riot_tag}</SummonerText>
                    </ToSummonerLink>
                </TextWrapper>
                {data.pro_strm_status ? <InflueWrapper>
                    <InfluInfo
                        maxWidthText={90}
                        influData={{
                            status: data.pro_strm_status,
                            name: data.pro_strm_name
                        }}
                    />
                </InflueWrapper> : null}
            </NameCenter>
            {onHover &&
                <CopyToClipboard onCopy={handleCopy} text={`${data.riot_name} ${data.riot_tag}`}>
                    <SummonerHoverButton>
                        복사
                    </SummonerHoverButton>
                </CopyToClipboard>}
            {copy &&
                <CopyAbsolute>
                    클립보드에 링크가 복사되었습니다.
                </CopyAbsolute>
            }
        </SummonerHoverBox>
    )
}
const MostChampsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const ImgWrapper = styled.div`
  .imgChamp {
    width: 36px;
    height: 36px;
  }

  .imgDiv {
    border-radius: 999px;
  }
`;

const MostChamps = ({list = []}) => {
    return (
        <MostChampsWrapper>
            {Array.isArray(list) && list.map((data) => {
                return (
                    <ImgWrapper key={data}>
                        <ChampionImageWithLane champion_id={Number(data)} borderRadius={'4px'}/>
                    </ImgWrapper>
                )
            })}
        </MostChampsWrapper>
    );
};
export default CustomClanDetailTable;